/**
 * 模組頁面代碼: 1220-UI
 * 模組說明: 梯控申請資料功能頁面
 * @module ElevatorApplyContainer
 */

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
//import Sidebar from '../../features/main-frame/components/Sidebar';
import ElevatorApplyPage from './components/ElevatorApplyPage';
import ElevatorApplyModal from './components/ElevatorApplyModal';
import DefaultPeriodModal from './components/DefaultPeriodModal';
import { ImportDataModal } from '../../components/ImportDataModal';
import { AlertModal, AlertModalModeEnums } from '../../components/AlertModal';
import { MessageModal, MessageModalModeEnums } from '../../components/MessageModal';
import ImportProgressModal from '../../components/ImportProgressModal';

// ----- import from local actions -----
import {
    fetchBuildingSelection,
    updateDefaultPeriod,
} from '../../redux/actions/BuildingActions';
import {
    addApply,
    editApply,
    editApplyStatus,
    fetchApply,
    fetchApplyList,
    resetPassword,
    importApply,
    resetVenderId,
} from '../../redux/actions/ApplyActions';

// ----- constants and enums -----
const ElevatorApplyModalModeEnums = {
    NEW: 'new',
    EDIT: 'edit',
};

const ACTION_TARGET_ELEVATOR_APPLY = 'elevatorApply';
const ACTION_TARGET_APPLICANT = 'applicant';

const RESPONSE_OK = 200;
const TITLE_APPLY_STATUS = '修改梯控申請狀態';
const TITLE_APPLICANT_PASSWORD = '重設申請人密碼';
const TITLE_APPLICANT_IMPORT = '匯入申請人資料';
const TITLE_APPLICANT_VENDERID = '重設申請人手機驗證碼';

class ElevatorApplyContainer extends BaseComponent {
    constructor(props) {
        super(props);
        // 創建 ref
        this.elevatorApplyModalRef = React.createRef();
        this.defaultPeriodModalRef = React.createRef();
        this.importDataModalRef = React.createRef();
        this.alertModalRef = React.createRef();
        this.messageModalRef = React.createRef();
        this.elevatorApplyModal = null;
        this.defaultPeriodModal = null;
        this.importDataModal = null;
        this.alertModal = null;
        this.messageModal = null;

        this.state = {
            needElevatorApplyLoad: false,
            elevatorApplyModalMode: ElevatorApplyModalModeEnums.NEW,
            actionMode: AlertModalModeEnums.ENABLE,
            actionTarget: '',
            applDetail: null,
            applDetailId: null,
            alertMessage: '',
            alertMemo: '',
            actionIds: [],
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
            newApplication: false,
            toggleDefaultPersiodModal: false,
            search: { buildingId: 0, elevatorId: 0, applicantName: '', applicantType: '' },
            isProgressModalOpen: false,
            progress: 0,
            statusMessage: '',
            reloadApplyModal: false,
        };
        this.toggleElevatorApplyModal = this.toggleElevatorApplyModal.bind(this);
        this.toggleDefaultPeriodModal = this.toggleDefaultPeriodModal.bind(this);
        this.toggleImportDataModal = this.toggleImportDataModal.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    toggleElevatorApplyModal(isShow, mode = ElevatorApplyModalModeEnums.NEW, index = null) {
        this.setState({ reloadApplyModal: true });
        if (this.elevatorApplyModal) {
            if (mode === ElevatorApplyModalModeEnums.EDIT) {
                this.setState({ applDetail: this.props.applDetailList[index] });
            } else {
                this.setState({ applDetail: null });
            }

            if (isShow) {
                this.elevatorApplyModal.show();
            } else {
                this.elevatorApplyModal.hide();
            }
            this.setState({ elevatorApplyModalMode: mode });
        }
    }

    toggleDefaultPeriodModal(isShow) {
        if (this.defaultPeriodModal) {
            if (isShow) {
                this.defaultPeriodModal.show();
            } else {
                this.defaultPeriodModal.hide();
            }
            this.setState({ toggleDefaultPersiodModal: true });
        }
    }

    toggleImportDataModal(isShow) {
        if (this.importDataModal) {
            if (isShow) {
                this.importDataModal.show();
            } else {
                this.importDataModal.hide();
            }
        }
    }

    toggleAlertModal(isShow, mode = AlertModalModeEnums.ENABLE, target, message = '', applDetailIds = [], memo = '') {
        if (this.alertModal) {
            if (isShow) {
                let alertMessage = message;
                if (alertMessage === '') {
                    let length = applDetailIds.length;
                    if (mode === AlertModalModeEnums.ENABLE) {
                        alertMessage = `啟用 [ ${length} ] 筆資料`;
                    } else if (mode === AlertModalModeEnums.DISABLE) {
                        alertMessage = `停用 [ ${length} ] 筆資料`;
                    } else if (mode === AlertModalModeEnums.APPROVE) {
                        alertMessage = `核可 [ ${length} ] 筆資料`;
                    }
                }
                this.setState({ actionMode: mode });
                this.setState({ alertMessage: alertMessage });
                this.setState({ actionTarget: target});
                this.setState({ actionIds: applDetailIds });
                this.setState({ alertMemo: memo });
                this.alertModal.show();
            } else {
                this.alertModal.hide();
            }
        }
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.INFO, title = '', message = '') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    onImportDataHandle(data) {
        let applicants = [];

        // Open progress modal
        this.setState({ isProgressModalOpen: true, progress: 10, statusMessage: '匯入中...' });

        const interval = setInterval(() => {
            let progress = this.state.progress;
            if (progress < 100) {
                progress += 10;
                this.setState({ progress: progress, statusMessage: '匯入中...' });
            }
        }, 200);

        data.forEach((row) => {
            applicants.push({
                buildingName: row['大樓名稱'],
                applicantName: row['姓名'],
                applicantType: row['申請者類型'],
                mobile: row['手機號碼'],
                houseNum: row['居住戶號(住戶填寫)'] !== ''? parseInt(row['居住戶號(住戶填寫)']) : null,
                floorDisplay: row['居住樓層(住戶填寫)'],
                roomNum: row['居住室號(住戶填寫)'],
                elevatorNum: row['電梯編號'],
                applyFloor: row['申請樓層'],
                validateTime: row['有效期限(YYYY-MM-DD HH:mm:ss)'],
            });
        });

        this.props.importApply(applicants).then((response) => {
            const statusCode = response.payload.code;
            if (statusCode !== RESPONSE_OK) {
                this.setState({ progress: 100, statusMessage: '匯入失敗' });
                this.toggleMessageModal(true, MessageModalModeEnums.ERROR, TITLE_APPLICANT_IMPORT, response.payload);
            } else {
                setTimeout(() => {
                    const { buildingId, elevatorId, applicantName, applicantType } = this.state.search;
                    this.props.fetchApplyList(buildingId, elevatorId, applicantName, applicantType).then(() => {
                        this.setState({ needElevatorApplyLoad: true });
                        this.toggleImportDataModal(false);
                        // Close progress modal
                        this.setState({ progress: 100, statusMessage: '匯入完成' });
                        clearInterval(interval);
                        setTimeout(() => {
                            this.setState({ isProgressModalOpen: false });
                            // output import result
                            const message = response.payload.message || '';
                            if (message !== '') {
                                this.toggleMessageModal(true, MessageModalModeEnums.INFO, TITLE_APPLICANT_IMPORT, message);
                            }
                        }, 1000);
                    });
                }, 1000);
            }
        });
    }

    onConfirm() {
        const actionTarget = this.state.actionTarget;
        const actionMode = this.state.actionMode;
        const actionIds = this.state.actionIds;

        if (actionTarget === ACTION_TARGET_ELEVATOR_APPLY) {
            if (actionMode === AlertModalModeEnums.ENABLE || actionMode === AlertModalModeEnums.DISABLE
                || actionMode === AlertModalModeEnums.APPROVE) {
                let status = '';
                switch (actionMode) {
                    case AlertModalModeEnums.ENABLE:
                        status = 'A';
                        break;
                    case AlertModalModeEnums.DISABLE:
                        status = 'I';
                        break;
                    case AlertModalModeEnums.APPROVE:
                        status = 'P';
                        break;
                }
                this.props.editApplyStatus(actionIds, status).then((response) => {
                    const statusCode = response.payload.code;
                    if (statusCode !== RESPONSE_OK) {
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.ERROR, TITLE_APPLY_STATUS, response.payload);
                    } else {
                        const { buildingId, elevatorId, applicantName, applicantType } = this.state.search;
                        this.props.fetchApplyList(buildingId, elevatorId, applicantName, applicantType).then(() => {
                            this.setState({ needElevatorApplyLoad: true });
                            this.toggleAlertModal(false);
                        });
                    }
                });
            }
        } else if (actionTarget === ACTION_TARGET_APPLICANT) {
            if (actionMode === AlertModalModeEnums.RESETPASSWORD) {
                this.props.resetPassword(actionIds[0]).then((response) => {
                    const statusCode = response.payload.code;
                    if (statusCode !== RESPONSE_OK) {
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.ERROR, TITLE_APPLICANT_PASSWORD, response.payload);
                    } else {
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.INFO, TITLE_APPLICANT_PASSWORD, "密碼重設成功");
                    }
                });
            }
            if (actionMode === AlertModalModeEnums.RESETVENDERID) {
                this.props.resetVenderId(actionIds[0]).then((response) => {
                    const statusCode = response.payload.code;
                    if (statusCode !== RESPONSE_OK) {
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.ERROR, TITLE_APPLICANT_VENDERID, response.payload);
                    } else {
                        this.toggleAlertModal(false);
                        this.toggleMessageModal(true, MessageModalModeEnums.INFO, TITLE_APPLICANT_VENDERID, "手機驗證碼重設成功");
                    }
                });
            }
        }
    }

    componentDidMount() {
        // 頁面所需資料初始化
        this.props.fetchBuildingSelection();
        this.props.fetchApplyList(0, 0, '', '').then(() => {
            this.setState({ needElevatorApplyLoad: true });
        });
        this.elevatorApplyModal = new bootstrap.Modal(this.elevatorApplyModalRef.current);
        this.defaultPeriodModal = new bootstrap.Modal(this.defaultPeriodModalRef.current);
        this.importDataModal = new bootstrap.Modal(this.importDataModalRef.current);
        this.alertModal = new bootstrap.Modal(this.alertModalRef.current);
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }
    
    componentDidUpdate(prevProps, prevState) {
        const socketMessage = this.props.newSocketMessage;
        if (socketMessage && prevProps.newSocketMessage !== socketMessage) {
            // 處理新的 socket 消息
            if (socketMessage && socketMessage.event === 'new_application') {
                this.setState({ newApplication: true });
            }
        }
    }

    componentWillUnmount() {
        this.toggleElevatorApplyModal(false);
        this.toggleDefaultPeriodModal(false);
        this.toggleImportDataModal(false);
        this.toggleAlertModal(false);
        this.toggleMessageModal(false);
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {/* <Sidebar /> */}
                        <ElevatorApplyPage
                            {...this.props}
                            needElevatorApplyLoad={this.state.needElevatorApplyLoad}
                            setNeedElevatorApplyLoad={(bLoad) => this.setState({ needElevatorApplyLoad: bLoad })}
                            newApplication={this.state.newApplication}
                            setNewApplication={(bNew) => this.setState({ newApplication: bNew })}
                            onDefaultPeriod={() => this.toggleDefaultPeriodModal(true)}
                            onNewApply={() => this.toggleElevatorApplyModal(true, ElevatorApplyModalModeEnums.NEW)}
                            onImportData={() => this.toggleImportDataModal(true)}
                            onEditApply={(index) => this.toggleElevatorApplyModal(true, ElevatorApplyModalModeEnums.EDIT, index)}
                            onEditApplyStatus={(mode, message, applDetialId) => this.toggleAlertModal(true, mode, ACTION_TARGET_ELEVATOR_APPLY, message, [applDetialId])}
                            onResetPassword={(mode, message, memo, applicantId) => this.toggleAlertModal(true, mode, ACTION_TARGET_APPLICANT, message, [applicantId], memo)}
                            onResetVenderId={(mode, message, memo, applicantId) => this.toggleAlertModal(true, mode, ACTION_TARGET_APPLICANT, message, [applicantId], memo)}
                            onBatchHandle={(mode, applDetialIds) => this.toggleAlertModal(true, mode, ACTION_TARGET_ELEVATOR_APPLY, '', applDetialIds)}
                            setSearchElevatorApply={(buildingId, elevatorId, applicantName, applicantType) => {
                                this.setState({ search: { buildingId, elevatorId, applicantName, applicantType } });
                            }}
                        />
                    </div>
                </div>
                <Footer />
                <ElevatorApplyModal 
                    {...this.props}
                    ref={this.elevatorApplyModalRef}
                    mode={this.state.elevatorApplyModalMode}
                    applDetail={this.state.applDetail}
                    searchElevatorApply={this.state.search}
                    reloadApplyModal={this.state.reloadApplyModal}
                    setNeedElevatorApplyLoad={(bLoad) => this.setState({ needElevatorApplyLoad: bLoad })}
                    setReloadApplyModal={(bReload) => this.setState({ reloadApplyModal: bReload })}
                    onErrorHandle={(title, message) => this.toggleMessageModal(true, MessageModalModeEnums.ERROR, title, message)}
                />
                <DefaultPeriodModal 
                    {...this.props}
                    ref={this.defaultPeriodModalRef}
                    onLoad={this.state.toggleDefaultPersiodModal}
                    setLoad={(bLoad) => this.setState({ toggleDefaultPersiodModal: bLoad })}
                    onShowMessageModal={(mode, title, message) => {
                        this.toggleMessageModal(true, mode, title, message);
                    }}
                />
                <ImportDataModal
                    ref={this.importDataModalRef}
                    onDataHandle={(data) => this.onImportDataHandle(data)}
                />
                <AlertModal
                    ref={this.alertModalRef}
                    mode={this.state.actionMode}
                    message={this.state.alertMessage}
                    memo={this.state.alertMemo}
                    onConfirm={() => this.onConfirm()}
                    onCancel={() => this.setState({ needElevatorApplyLoad: true })}
                />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
                <ImportProgressModal
                    isOpen={this.state.isProgressModalOpen}
                    progress={this.state.progress} 
                    statusMessage={this.state.statusMessage}
                    onClose={() => this.setState({ isProgressModalOpen: false })}
                />
            </React.Fragment>
        );
    }
}

ElevatorApplyContainer.propTypes = {
    userPermissions: PropTypes.array,
    buildingSelection: PropTypes.array,
    applDetailList: PropTypes.array,
    newSocketMessage: PropTypes.any,
};

ElevatorApplyContainer.defaultProps = {
    userPermissions: [],
    buildingSelection: [],
    applDetailList: [],
    newSocketMessage: null,
};

function mapStateToProps(state) {
    return {
        userPermissions: state.access.userPermissions,
        buildingSelection: state.building.buildingSelection.data,
        applDetailList: state.apply.applDetailList.data,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBuildingSelection: () => {
            return dispatch(fetchBuildingSelection());
        },
        addApply: (applDetail) => {
            return dispatch(addApply(applDetail));
        },
        editApply: (applDetail) => {
            return dispatch(editApply(applDetail));
        },
        editApplyStatus: (applDetailIds, status) => {
            return dispatch(editApplyStatus({ applDetailIds, status} ));
        },
        resetPassword: (applicantId) => {
            return dispatch(resetPassword({ applicantId }));
        },
        fetchApply: (applDetailId) => {
            return dispatch(fetchApply(applDetailId));
        },
        fetchApplyList: (buildingId, elevatorId, applicantName, applicantType) => {
            return dispatch(fetchApplyList({ buildingId, elevatorId, applicantName, applicantType }));
        },
        updateDefaultPeriod: (buildingId, defaultPeriod) => {
            return dispatch(updateDefaultPeriod({ buildingId, defaultPeriod }));
        },
        importApply: (applicants) => {
            return dispatch(importApply({ applicants }));
        },
        resetVenderId: (applicantId) => {
            return dispatch(resetVenderId({ applicantId }));
        }
    };    
}

export default connect(mapStateToProps, mapDispatchToProps)(ElevatorApplyContainer);